import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions, KlarnaActions } from 'actions';
import ItemDetails from 'components/Store/ItemDetails';
import Loader from 'components/Material/Loader';
import Constants from 'Constants';
import CountdownTimer from 'components/CountdownTimer';
import { Units, Colors } from 'Css';
import { history } from 'helpers';
import { TextField, RaisedButton } from 'material-ui';
import * as SvgIcons from 'components/Material/SvgIcons';

const isValidSSN = /^\d{6,8}[-|(\s)]{0,1}\d{4}$/;
const isValidPhone = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
const isValidEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const css = oxygenCss({
  root: {
    padding: Units.base
  },

  details: {
    padding: Units.base * 4
  },

  method: {
    textAlign: 'right',
    '>DIV': {
      display: 'inline-block',
      width: 128,
      textAlign: 'left'
    }
  },
  container: {
    padding: Units.base
  },
  flex: {
    display: 'flex',
    padding: Units.base / 2
  },
  flexChild: {
    padding: Units.base / 2,
    flex: '1'
  },
  courseBought: {
    textAlign: 'center',
    padding: Units.keyline
  },
  error: {
    fontSize: '24px',
    display: 'inline',
    color: '#FF3030'
  },
  backButton: {
    cursor: 'pointer',
    position: 'relative',
    height: 32,
    minWidth: 72,
    top: -16,
    left: 24,
    display: 'inline-block',
    lineHeight: '32px',
    padding: `0 ${Units.base * 2}px`,
    borderRadius: 16,
    backgroundColor: Colors.theme.Light.card,
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',
    '@phone': {
      position: 'absolute',
      left: 16,
      top: 16
    },
    '>SVG': {
      verticalAlign: 'middle',
      marginRight: Units.base
    }
  }
});

class KlarnaOnlineForm extends Component {
  static propTypes = {
    ssn: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    street: PropTypes.string,
    zip: PropTypes.string,
    loading: PropTypes.bool,
    item: PropTypes.object,
    method: PropTypes.string,
    error: PropTypes.string,
    paymentComplete: PropTypes.bool,
    paymentLoading: PropTypes.bool
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object,
    router: PropTypes.object
  };

  state = {
    ssnError: null,
    phoneError: null,
    emailError: null
  };

  requestAddress = () => {
    const { ssn } = this.props;
    KlarnaActions.getAddressesBySsn(ssn);
  };

  validSSN(ssn) {
    return isValidSSN.test(ssn.toLowerCase());
  }

  validPhone(phone) {
    return isValidPhone.test(phone);
  }

  validEmail(email) {
    return isValidEmail.test(email.toLowerCase());
  }

  handlePersonalNumberChange = event => {
    const { value } = event.target;
    const { getIntlMessage } = this.context;

    if (value != '') {
      if (this.validSSN(value)) {
        this.setState({ ssnError: null });
      } else {
        this.setState({
          ssnError: getIntlMessage('payment.klarna.personalNumberError')
        });
      }
    } else {
      this.setState({ ssnError: null });
    }

    KlarnaActions.change({
      ssn: value
    });
  };

  handleTelephoneNumberChange = event => {
    const { value } = event.target;
    const { getIntlMessage } = this.context;

    if (value != '') {
      if (this.validPhone(value)) {
        this.setState({ phoneError: null });
      } else {
        this.setState({
          phoneError: getIntlMessage('payment.klarna.phoneError')
        });
      }
    } else {
      this.setState({ phoneError: null });
    }

    KlarnaActions.change({
      phone: value
    });
  };

  handleEmailChange = event => {
    const { value } = event.target;
    const { getIntlMessage } = this.context;

    if (value != '') {
      if (this.validEmail(value)) {
        this.setState({ emailError: null });
      } else {
        this.setState({
          emailError: getIntlMessage('payment.klarna.emailError')
        });
      }
    } else {
      this.setState({ emailError: null });
    }

    KlarnaActions.change({
      email: value
    });
  };

  changePropertyWithEvent = (property, event) => {
    const { value } = event.target;

    KlarnaActions.change({
      [property]: value
    });
  };

  change(property, value) {
    KlarnaActions.change({
      [property]: value
    });
  }

  redirect = () => {
    if (this.props.loggedIn) {
      history.push(`/dashboard`);
    } else {
      StoreOverviewActions.reset();
    }
  };

  completePurchase = () => {
    const {
      firstName,
      lastName,
      city,
      country,
      street,
      zip,
      phone,
      email,
      ssn
    } = this.props;
    const address = {
      ssn,
      firstName,
      lastName,
      city,
      country,
      street,
      zip,
      phone,
      email
    };
    StoreOverviewActions.startPayment(
      Constants.paymentProviders.KLARNA,
      null,
      null,
      address
    );
  };

  renderChosenMethod() {
    const { method } = this.props;
    const { getIntlMessage } = this.context;
    if (method === 'account') {
      return (
        <div>
          <img src="https://cdn.klarna.com/1.0/shared/image/generic/logo/sv_se/basic/blue-black.png?width=100" />
          <br />
          {getIntlMessage('payment.klarna.account')}
        </div>
      );
    }
    return (
      <div>
        <img src="https://cdn.klarna.com/1.0/shared/image/generic/logo/sv_se/basic/blue-black.png?width=100" />
        <br />
        {getIntlMessage('payment.klarna.invoice')}
      </div>
    );
  }

  renderDetails() {
    const {
      email,
      phone,
      city,
      country,
      firstName,
      lastName,
      street,
      zip,
      paymentLoading
    } = this.props;
    const { getIntlMessage } = this.context;
    return (
      <div className={css.details}>
        <div className={css.method}>{this.renderChosenMethod()}</div>
        <div className={css.container}>
          <TextField
            floatingLabelText={getIntlMessage('payment.klarna.firstName')}
            value={firstName}
            fullWidth
          />
          <TextField
            floatingLabelText={getIntlMessage('payment.klarna.lastName')}
            value={lastName}
            fullWidth
          />
          <TextField
            hintText={getIntlMessage('payment.klarna.emailFormat')}
            floatingLabelText={getIntlMessage('payment.klarna.email')}
            value={email}
            fullWidth
            disabled
          />
          <TextField
            hintText={getIntlMessage('payment.klarna.phoneNumberFormat')}
            floatingLabelText={getIntlMessage('payment.klarna.phone')}
            value={phone}
            fullWidth
            disabled
          />
          <TextField
            floatingLabelText={getIntlMessage('payment.klarna.street')}
            value={street}
            fullWidth
          />
          <TextField
            floatingLabelText={getIntlMessage('payment.klarna.zip')}
            value={zip}
            fullWidth
          />
          <TextField
            floatingLabelText={getIntlMessage('payment.klarna.city')}
            value={city}
            fullWidth
          />
          <TextField
            floatingLabelText={getIntlMessage('payment.klarna.country')}
            value={country}
            fullWidth
          />
        </div>
        {paymentLoading ? (
          <Loader />
        ) : (
          <RaisedButton
            secondary
            label={getIntlMessage('payment.completePurchase')}
            onTouchTap={this.completePurchase}
          />
        )}
      </div>
    );
  }

  renderPersonNumber() {
    const {
      method,
      ssn,
      phone,
      email,
      city,
      country,
      firstName,
      lastName,
      street,
      zip,
      loading,
      ...other
    } = this.props;
    const { getIntlMessage } = this.context;
    const { ssnError, phoneError, emailError } = this.state;
    return (
      <div className={css.details}>
        <div className={css.container}>
          <TextField
            fullWidth
            errorText={ssnError}
            hintText={getIntlMessage('payment.klarna.personalNumberFormat')}
            value={ssn}
            floatingLabelText={getIntlMessage(
              'payment.klarna.personalOrganisationalNumber'
            )}
            floatingLabelStyle={{ top: '10px' }}
            onChange={this.handlePersonalNumberChange}
          />
          <TextField
            fullWidth
            errorText={phoneError}
            value={phone}
            hintText={getIntlMessage('payment.klarna.phoneNumberFormat')}
            floatingLabelText={getIntlMessage('payment.klarna.phone')}
            onChange={this.handleTelephoneNumberChange}
          />
          <TextField
            fullWidth
            errorText={emailError}
            value={email}
            hintText={getIntlMessage('payment.klarna.emailFormat')}
            floatingLabelText={getIntlMessage('payment.klarna.email')}
            onChange={this.handleEmailChange}
          />

          <RaisedButton
            disabled={
              !ssn ||
              !email ||
              !phone ||
              !!ssnError ||
              !!emailError ||
              !!phoneError
            }
            secondary
            label={getIntlMessage('Continue')}
            onTouchTap={this.requestAddress}
          />
        </div>
        {firstName && this.renderDetails()}
      </div>
    );
  }

  back = () => {
    StoreOverviewActions.setPaymentMethod(null);
  };

  render() {
    const {
      error,
      paymentComplete,
      cart,
      method,
      ssn,
      city,
      country,
      firstName,
      lastName,
      street,
      zip,
      loading,
      ...other
    } = this.props;
    const [item] = cart;
    let detail;
    if (loading) {
      detail = <Loader />;
    } else {
      if (error) {
        detail = (
          <div className={css.courseBought}>
            <CountdownTimer
              seconds={2}
              color="#777"
              alpha={0.3}
              size={128}
              onComplete={this.reset}
            />
            <br />
            <div className={css.error}>{error}</div>
          </div>
        );
      } else if (paymentComplete) {
        detail = (
          <div className={css.courseBought}>
            <CountdownTimer
              seconds={2}
              color="#777"
              alpha={0.3}
              size={128}
              onComplete={this.redirect}
            />
            <br />
            {this.context.getIntlMessage('store.purchaseSuccess')}
          </div>
        );
      } else if ((method === 'account' || method === 'invoice') && !firstName) {
        detail = this.renderPersonNumber();
      } else if (firstName) {
        detail = this.renderDetails();
      }
    }

    return (
      <div>
        <ItemDetails {...item} />
        <div className={css.backButton} onTouchTap={this.back}>
          <SvgIcons.NavigationArrowBack />
          {this.context.getIntlMessage('menu.Back')}
        </div>
        {detail}
      </div>
    );
  }
}

export default KlarnaOnlineForm;



// WEBPACK FOOTER //
// ./src/js/components/Store/KlarnaOnlineForm.js